import type {
  SLAFilteringDtoOptions,
  SLASortingDtoOptions,
} from '@issuemanager/api-client';
import { getSortingModelByField } from '@issuemanager/apps/client/components';
import type { GridSortModel } from '@mui/x-data-grid-pro';
import {
  SLA_FIELD_DAYS,
  SLA_FIELD_ESCALATION,
  SLA_FIELD_ISSUE_SEVERITY,
  SLA_FIELD_ISSUE_SUBTYPE,
  SLA_FIELD_ISSUE_TYPE,
} from '../constants';
import type { SLAsGridFilterModel } from '../types';

export function useSLAsGridQueryParams(
  filterModel: SLAsGridFilterModel,
  sortModel: GridSortModel,
): {
  filter: SLAFilteringDtoOptions;
  sort: SLASortingDtoOptions;
} {
  return {
    filter: useSLAsGridQueryFilterParam(filterModel),
    sort: useSLAGridQuerySortParam(sortModel),
  };
}

function useSLAsGridQueryFilterParam(
  filterModel: SLAsGridFilterModel,
): SLAFilteringDtoOptions {
  const issueTypeFilter = filterModel[SLA_FIELD_ISSUE_TYPE];
  const issueSubtypeFilter = filterModel[SLA_FIELD_ISSUE_SUBTYPE];
  const severityFilter = filterModel[SLA_FIELD_ISSUE_SEVERITY];

  const issueType = issueTypeFilter?.map((issueType) => issueType.id);
  const issueSubtype = issueSubtypeFilter?.map(
    (issueSubtype) => issueSubtype.id,
  );
  const severity = severityFilter?.map((severity) => severity.value);

  return {
    issueType,
    issueSubtype,
    severity,
  };
}

function useSLAGridQuerySortParam(
  sortModel: GridSortModel,
): SLASortingDtoOptions {
  const issueType = getSortingModelByField(sortModel, SLA_FIELD_ISSUE_TYPE);
  const issueSubtype = getSortingModelByField(
    sortModel,
    SLA_FIELD_ISSUE_SUBTYPE,
  );
  const severity = getSortingModelByField(sortModel, SLA_FIELD_ISSUE_SEVERITY);
  const slaDays = getSortingModelByField(sortModel, SLA_FIELD_DAYS);
  const escalationDays = getSortingModelByField(
    sortModel,
    SLA_FIELD_ESCALATION,
  );

  return {
    issueType,
    issueSubtype,
    severity,
    slaDays,
    escalationDays,
  };
}
